export default "__VITE_ASSET__DH1S9b3R__"